var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.66 21.7c-.368 0-.66-.277-.66-.628 0-3.3 2.825-5.972 6.28-5.972h6.391c3.454 0 6.28 2.672 6.28 5.972 0 .35-.292.628-.66.628zm8.69-8.8c-2.733 0-4.95-2.235-4.95-4.958A4.95 4.95 0 0 1 12.35 3a4.94 4.94 0 0 1 4.95 4.942 4.955 4.955 0 0 1-4.95 4.958"
})));
export default SvgUser;